import { SdkConfigureStore } from "@payping/redux";
import { SdkStoreStates } from "@payping/redux/reducers";
import * as Sentry from "@sentry/react";

import dashboardPreference, { DashboardPreferenceState } from "@/redux/reducers/dashboardPreference";
import loginRedirect, { LoginRedirectState } from "../reducers/loginRedirect";
import serviceWorker, { ServiceWorkerState } from "../reducers/serviceWorker";
import dashboard, { DashboardReduxReducerState } from "../reducers/dashboard";

import persistConfig from "./persistConfig";

export interface AppStoreStates extends SdkStoreStates {
  loginRedirect: LoginRedirectState;
  serviceWorker: ServiceWorkerState;
  dashboard: DashboardReduxReducerState;
  dashboardPreference: DashboardPreferenceState;
}

const sentryReduxEnhancer = Sentry.createReduxEnhancer();

const appReducers = {
  loginRedirect,
  serviceWorker,
  dashboard,
  dashboardPreference,
};

export const reduxConfig: SdkConfigureStore = {
  appEnhancers: [sentryReduxEnhancer],
  appPersistConfig: persistConfig,
  // @ts-ignore wrong type
  appReducers,
};
